export default {
  containers: {
    location_info: 'Información de ubicación',
    attributes: 'Atributos',
    links: 'Enlaces',
  },
  labels: {
    title: 'Título',
    phone_number: 'Número de teléfono',
    description: 'Descripción',
    website: 'Sitio web',
    address: 'Dirección',
    regular_hours: 'Horario regular',
    page_urls: 'URLs de página',
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',
    sunday: 'Domingo',
    twenty_four_hours: '24h',
    open_24_hours: 'Abierto 24 horas',
    open_time: 'Hora de apertura',
    close_time: 'Hora de cierre',
    url: 'URL',
    provider_type: 'Tipo de proveedor',
    provider_types: {
      merchant: 'Comerciante',
      aggregator: 'Agregador',
    },
    place_action_type: 'Tipo',
    is_preferred: 'Preferido',
    place_action_types: {
      appointment: 'Reservar una cita',
      online_appointment: 'Reservar una cita en línea',
      dining_reservation: 'Enlace de reservas',
      food_ordering: 'Pedido de comida a domicilio y/o para llevar',
      food_delivery: 'Enlace de entrega',
      food_takeout: 'Enlace para llevar',
      shop_online: 'Compras con entrega y/o recogida',
    },
    no_links: 'No hay enlaces disponibles para este negocio',
    url_menu: 'Enlace del menú',
    url_reservations: 'Enlace de reservas',
  },
  placeholders: {
    title: 'Título',
    phone_number: 'Número de teléfono',
    description: 'Descripción',
    website: 'Sitio web',
    address: 'Dirección',
    regular_hours: 'Horario regular',
    page_urls: 'URLs de página',
    address_line_1: 'Dirección línea 1',
    postal_code: 'Código postal',
    locality: 'Localidad',
    region_code: 'Código de región',
    language_code: 'Código de idioma',
    select_time: 'Seleccionar hora',
    url: 'URL',
  },
  buttons: {
    submit: 'Enviar',
    add: 'Añadir',
    delete: 'Eliminar',
    generate_description: 'Generar descripción con IA',
  },
  validation: {
    required: 'Este campo es obligatorio',
    invalid_url: 'URL no válida',
  },
  toasts: {
    success: '¡Cambios guardados!',
    description_generation_failed: 'No se pudo generar una descripción. Inténtalo de nuevo.',
  },
};
